<template>
    <div id="main-rav" class="main">
        <h1 v-if="options.hostname === 'localhost'">[TEST] Medialib Roger-Albert Voyage (medialib.gestour.w3b-experience.net)</h1>
        <div class="image-list">
            <RavImagesList :options="options"/>
        </div>
    </div>
</template>

<script>
import RavImagesList from "./components/RavImagesList.vue";
export default {
  name: "App",
  components: {
    RavImagesList
  },
  props: {
    options: {
        type: Object,
        default: function() { return {} }
    }
  }
};
</script>

<!-- <style scoped></style> -->